<template>
	<div class="body">
		<div class="close-btn" v-on:click="close">
			<i title="close" class="material-icons md-18">close</i>
		</div>
		<div class="title">EDIT COLLECTION NAME</div>
		<div class="p-3">
			<form class="category form-group" v-on:submit.prevent="formSubmit">
				<div class="modal-property-row">
					<input type="text" class="form-control"
						placeholder="Enter a name" v-model="rec.name"
						v-bind:class="{'is-invalid':error}"/>
					<div class="invalid-feedback">
						{{error}}
				   </div>
				</div>
				<div class="modal-actions">
					<button class="btn btn-dark float-right" type="submit">Save</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>

export default {
	name:'collectionEdit',
	props: {
		collection:{
			type:Object,
		},
	},
	computed:{
		planActive:function(){
			return this.$store.state.plan.active;
		},
	},
	data: function(){
		return {
			rec: {
				...this.collection,
			},
			error:null,
			loading: true,
			loadError: null,
		}
	},
	methods:{
		close:function(){
			this.$emit('close');
		},
		formSubmit:async function(){
			try {
				this.loadError = null;
				this.loading = true;
				await this.$store.dispatch('COLLECTION_SAVE', {collectionId:this.$route.params.collectionId, name:this.rec.name});
				this.$emit('close');
				this.loading = false;
			} catch(e){
				this.loadError = e;		
			}
		},
	}
};

</script>


// WEBPACK FOOTER //
// src/components/collection/collection-edit.vue